var _circle, _mask, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_410_502)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_410_502",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9796 15.3909L16.649 26.8335C16.5593 26.8928 16.4602 26.9362 16.3576 26.9682C14.3608 27.5914 13.1949 29.6858 13.7412 31.7248C14.2876 33.7638 16.3445 34.9947 18.3853 34.536C18.4902 34.5124 18.5978 34.5004 18.7051 34.5069L39.4351 35.7512C40.1164 35.7921 40.6376 35.1534 40.4609 34.4941L35.4965 15.9666C35.3199 15.3073 34.5492 15.0149 33.9796 15.3909Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9796 15.3909L32.8776 13.7219L32.8776 13.7219L33.9796 15.3909ZM39.4351 35.7512L39.3153 37.7476L39.3153 37.7476L39.4351 35.7512ZM18.3853 34.536L18.8239 36.4873L18.3853 34.536ZM18.7051 34.5069L18.5853 36.5033L18.7051 34.5069ZM16.649 26.8335L15.547 25.1645L16.649 26.8335ZM16.3576 26.9682L15.7617 25.059L16.3576 26.9682ZM17.751 28.5026L35.0816 17.06L32.8776 13.7219L15.547 25.1645L17.751 28.5026ZM15.6731 31.2072C15.4056 30.2087 15.9766 29.1822 16.9534 28.8773L15.7617 25.059C12.745 26.0005 10.9842 29.1628 11.8094 32.2424L15.6731 31.2072ZM17.9468 32.5847C16.9484 32.8091 15.9406 32.2056 15.6731 31.2072L11.8094 32.2424C12.6346 35.322 15.7406 37.1803 18.8239 36.4873L17.9468 32.5847ZM39.5549 33.7548L18.8249 32.5105L18.5853 36.5033L39.3153 37.7476L39.5549 33.7548ZM38.5291 35.0118C38.3524 34.3525 38.8736 33.7139 39.5549 33.7548L39.3153 37.7476C41.3593 37.8703 42.9228 35.9544 42.3928 33.9765L38.5291 35.0118ZM33.5647 16.4843L38.5291 35.0118L42.3928 33.9765L37.4284 15.449L33.5647 16.4843ZM35.0816 17.06C34.512 17.436 33.7413 17.1436 33.5647 16.4843L37.4284 15.449C36.8984 13.4711 34.5864 12.5937 32.8776 13.7219L35.0816 17.06ZM18.8239 36.4873C18.7883 36.4953 18.7044 36.5104 18.5853 36.5033L18.8249 32.5105C18.4912 32.4904 18.1921 32.5295 17.9468 32.5847L18.8239 36.4873ZM15.547 25.1645C15.6466 25.0988 15.7268 25.0699 15.7617 25.059L16.9534 28.8773C17.1935 28.8024 17.472 28.6868 17.751 28.5026L15.547 25.1645Z",
    fill: "white",
    mask: "url(#path-2-inside-1_410_502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.963 33.8421L21.9968 41.0276L24.7465 39.44L20.6938 25.2629",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7069 24.5868C40.0643 25.9205 39.0566 27.3493 37.4562 27.7781C37.1789 26.7432 37.1666 26.6969 36.8093 25.3633C36.4519 24.0296 36.3472 23.6384 36.1621 22.9485C37.7625 22.5197 39.3496 23.2532 39.7069 24.5868Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6178 20.9192C42.0556 22.3267 42.8909 25.4439 41.4834 27.8817",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6628 17.0654C45.4362 19.8213 47.0716 25.9249 44.3157 30.6982",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_410_502",
    x1: 2.79397e-7,
    y1: 30,
    x2: 60,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DD06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A90A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.abd27b6a468b2abe0549585fc07c0b21.svg";
export { ForwardRef as ReactComponent };